import request, { oauth } from "../request";

// 企微授权地址
export const wxWorkOAuthEntryApi = (data) => {
  return oauth.post(`/oauth/token`, data, {
    headers: { "X-CUS-Client-Id": data.clientId },
  });
};
// 微信授权地址
export const wxOAuthEntryApi = (data) => {
  return oauth.post(`/oauth/token`, data, {
    headers: { "X-CUS-Client-Id": data.clientId },
  });
};

// 企微获取员工信息
export const wxWorkGetUserInfoApi = () => {
  return request.get(`/wecom/auth/wxlogin`);
};

export const wxWorkSwitchUserInfoApi = ({ storeId, userRole }) => {
  return request.put(
    `/wecom/auth/switch-user-info?storeId=${storeId}&userRole=${userRole}`
  );
};

// 企业微信 JSSDK
export const getWxWorkJsapiInfo = (params) => {
  return request.get(`/wecom/auth/getWechatJsapiInfo`, { params });
};

// 企业微信 Agent JSSDK
export const getWxWorkAgentJsapiInfo = (params) => {
  return request.get(`/wecom/auth/getJsapiInfo`, { params });
};

// 根据userId获取微信用户信息
export const getCustomerInfoByExternalUserId = (userId) => {
  return request.get(`/wecom/customer/basic/${userId}`);
};

// 获取微信用户信息
export const getCustomerInfoApi = () => {
  return request.get(`/wechat/auth/wxlogin`);
};

// 微信 JSSDK
export const getWechatJsapiInfo = (params) => {
  return request.get(`/wechat/auth/getJsapiInfo`, { params });
};

// 获取微信JSSDK配置(使用CorpID)
export const getWechatJsapiInfoByCorpID = (params) => {
  return request.get(`/wechat/auth/getWechatJsapiInfo`, { params });
};
